<template>
	<div class="sm-top-nav">
		<button
			class="b360-hamburger-menu-icon"
			aria-label="collapse expand menu"
			@click="toggleExpandedSmallNav"
			:class="{ b360_menu_icon_inverse: expandedSmNav }"
		>
			<font-awesome-icon :icon="['fal', 'bars']" />
		</button>

		<router-link to="/" aria-label="Link to Brand 360 Home">
			<svg class="b360-logo" viewBox="0 0 876.78 128.07">
				<defs>
					<linearGradient
						id="linear-gradient-small"
						x1="1382.73"
						y1="2421.98"
						x2="1516.95"
						y2="2421.98"
						gradientTransform="translate(758.91 -2681.18) rotate(45)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0" stop-color="#a1cd57" />
						<stop offset="0.61" stop-color="#00a897" />
						<stop offset="1" stop-color="#005f9d" />
					</linearGradient>
					<linearGradient
						id="linear-gradient-small-2"
						x1="1382.73"
						y1="2442.95"
						x2="1516.95"
						y2="2442.95"
						xlink:href="#linear-gradient-small"
					/>
					<linearGradient
						id="linear-gradient-small-3"
						x1="728.93"
						y1="66.83"
						x2="876.78"
						y2="66.83"
						gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
						xlink:href="#linear-gradient-small"
					/>
				</defs>
				<title>B360</title>
				<g id="Layer_2" data-name="Layer 2">
					<g id="Layer_1-2" data-name="Layer 1">
						<path
							class="cls-1"
							d="M109.45,18.69c-.69-.69-1.41-1.38-2.15-2.06L82.58,41.35c.79.66,1.56,1.36,2.29,2.1a32.43,32.43,0,0,1,4.1,5,29,29,0,0,1,5,16.06,27.71,27.71,0,0,1-8.37,20.69,29,29,0,0,1-18,8.57,27.9,27.9,0,0,1-12.91-1.61L49.77,97c.19.08.37.17.56.24a37,37,0,0,0,13.79,2.86,34.19,34.19,0,0,0,13.81-2.48,36.87,36.87,0,0,0,12-8.18,35.64,35.64,0,0,0,7.85-11.52,35.19,35.19,0,0,0-4.63-35l-1.6-2.08L107.36,25l2.09,2.59a58.16,58.16,0,0,1-42.36,94.55v5.95A64.13,64.13,0,0,0,113.3,22.9C112.07,21.42,110.77,20,109.45,18.69Z"
						/>
						<path
							class="cls-2"
							d="M39.33,79.57a28.63,28.63,0,0,1-5-16,28,28,0,0,1,8.59-20.75,27.92,27.92,0,0,1,20.9-8.46,29.73,29.73,0,0,1,9.84,1.79l5-5c-.31-.14-.61-.28-.91-.4a36,36,0,0,0-13.89-2.72h-.13a36.19,36.19,0,0,0-13.67,2.54,34.83,34.83,0,0,0-11.44,7.73,35.81,35.81,0,0,0-3.45,46.84l1.55,2.07L20.84,103.09l-2.08-2.59A58.16,58.16,0,0,1,61.12,6V0A64.15,64.15,0,0,0,14.9,105.18c1.24,1.48,2.54,2.89,3.85,4.21.69.69,1.41,1.38,2.16,2L45.67,86.67q-1-.89-2-1.86A34.81,34.81,0,0,1,39.33,79.57Z"
						/>
						<path
							class="cls-3"
							d="M195.5,23a32,32,0,0,1,10.82,1.48,19.1,19.1,0,0,1,7.09,4.62,17.54,17.54,0,0,1,4.34,7.25A29.33,29.33,0,0,1,219,45q0,11.66-9.56,16.93a21.16,21.16,0,0,1,12.47,7.36,20.65,20.65,0,0,1,4.67,13.51,21.69,21.69,0,0,1-7,16.54q-7,6.54-18.73,6.53H178.36V23Zm1.21,37.58a21.41,21.41,0,0,0,7.09-1.1A15.59,15.59,0,0,0,209.45,56a12.33,12.33,0,0,0,3.41-5.27,22,22,0,0,0,.88-6.49,18.77,18.77,0,0,0-1.26-6.86,13.56,13.56,0,0,0-3.85-5.44,14.84,14.84,0,0,0-5.88-3.08,38.53,38.53,0,0,0-9.34-.88h-9.78V60.59Zm1.65,40.32a39.5,39.5,0,0,0,10.38-1,16.71,16.71,0,0,0,6.43-3.58,18.35,18.35,0,0,0,4.5-6A16.87,16.87,0,0,0,221.32,83a17.2,17.2,0,0,0-2.86-9.78,15,15,0,0,0-7.91-6,41.9,41.9,0,0,0-13.07-1.7H183.63v35.38Z"
						/>
						<path
							class="cls-3"
							d="M291.2,23a46.62,46.62,0,0,1,11.59,1.1,20.55,20.55,0,0,1,7.53,3.95,18.62,18.62,0,0,1,5.38,7.2A24.31,24.31,0,0,1,317.57,45q0,10.23-6.21,15.94t-17.2,5.71h-.32L321,105.85h-6l-27-39.22h-2.64v39.22H280V23Zm1.32,38.68a31.52,31.52,0,0,0,9-1,13.75,13.75,0,0,0,6.15-3.9,15.88,15.88,0,0,0,3.69-5.82,19.6,19.6,0,0,0,1-6.15,18.41,18.41,0,0,0-.83-5.44,17.49,17.49,0,0,0-2.2-4.73,12.75,12.75,0,0,0-3.35-3.4,15.92,15.92,0,0,0-3.9-2,20.36,20.36,0,0,0-4.45-.93c-1.68-.18-4.72-.28-9.12-.28h-3.19V61.69Z"
						/>
						<path
							class="cls-3"
							d="M399.53,20.22l34.61,85.63h-5.38l-11.1-27.24H381.29L370.2,105.85h-5.39ZM383.27,73.66h32.42l-16.16-40Z"
						/>
						<path
							class="cls-3"
							d="M483.15,21.91l69.55,73.4V23H558V108.6L488.42,34.66v71.19h-5.27Z"
						/>
						<path
							class="cls-3"
							d="M630.92,23q14.07,0,23.13,5.22a39.44,39.44,0,0,1,14.62,14.83,42.28,42.28,0,0,1,5.55,21.48,42.77,42.77,0,0,1-2.86,15.6,41.44,41.44,0,0,1-8.68,13.52,37.09,37.09,0,0,1-13.51,9.17,49.73,49.73,0,0,1-18.25,3h-15.6V23Zm-.1,77.9q11.74,0,19.88-4.5a34.85,34.85,0,0,0,13.19-13.08,36.31,36.31,0,0,0,5.05-18.79,38,38,0,0,0-2.8-14.61,35.08,35.08,0,0,0-8.24-12,34.23,34.23,0,0,0-11.76-7.58A43.76,43.76,0,0,0,630.82,28H620.6v73Z"
						/>
						<path
							class="cls-4"
							d="M760.68,103.41q-4.41,6.15-14.17,6.15t-13.67-5.63q-3.92-5.62-3.91-17.82V80.65h11.91v5.79q0,6.89,1.07,9.54t4.68,2.66a4.68,4.68,0,0,0,4.81-3.21q1.22-3.2,1.22-11.25t-1.57-11.46q-1.57-3.42-6.13-3.42h-3.6V59.62h3.51c3,0,5-1,6.12-3s1.67-5.3,1.67-9.89-.47-7.68-1.4-9.26a4.79,4.79,0,0,0-4.44-2.37,4.33,4.33,0,0,0-4.25,2.49q-1.21,2.49-1.21,8.66v2.52H729V46.14q0-11.45,4-16.74t13.5-5.29q9.48,0,13.94,5.46T765,46.14a27.61,27.61,0,0,1-2.14,11.55,11.2,11.2,0,0,1-6.45,6.25,13,13,0,0,1,6.74,7.4,38,38,0,0,1,2,13.39Q765.1,97.26,760.68,103.41ZM796.8,60.23q3-4,10.39-4t10.64,5.93q3.23,5.94,3.23,18.89v4.61q0,12.06-3.8,18t-14.34,5.93q-13,0-16.66-9.92-2.19-5.93-2.18-16.09V49.27q0-18.14,8.35-22.88,4.08-2.28,10.64-2.33,8.49,0,12.36,4.82t3.92,16.31v4.32H807.48V47.8c0-5-.29-8.4-.85-10.11s-2-2.57-4.28-2.57-3.77.92-4.48,2.76-1.07,5.31-1.07,10.44Zm1.35,35.56a4.85,4.85,0,0,0,4.77,2.75q3.42,0,4.63-2.23T808.76,88V80.08c0-4.69-.4-8-1.21-9.92a4.21,4.21,0,0,0-4.11-2.9,7.47,7.47,0,0,0-4.62,1.31,4.8,4.8,0,0,0-2,3.15v15.1Q796.8,93,798.15,95.79Zm74.14,7.83q-4.49,6-14.41,6t-14.4-6q-4.49-6-4.49-17.56V46.14q0-11,4.53-16.55t14.36-5.53q9.82,0,14.36,5.53t4.54,16.55V86.06Q876.78,97.64,872.29,103.62Zm-14.53-5a5.36,5.36,0,0,0,4.66-2.35q1.64-2.36,1.63-10V45.61q0-9.26-4.31-10.39A13.74,13.74,0,0,0,857,35a5,5,0,0,0-3.61,1.85q-1.74,1.84-1.74,8.69V86.3q0,7.78,1.55,10.06A5.14,5.14,0,0,0,857.76,98.64Z"
						/>
					</g>
				</g>
			</svg>
		</router-link>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	name: 'SmallNavBar',
	components: {},
	computed: mapState({
		expandedSmNav: (state) => state.menus.expandedSmallNav,
	}),
	methods: mapActions(['toggleExpandedSmallNav']),
};
</script>

<style scoped lang="scss">
.sm-top-nav {
	height: $top-nav-height;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: $base-padding;
	background-color: $white;
	width: 100%;
	position: relative;

	@include lg {
		display: none;
	}

	@include mobile {
		@include rem('min-width', 320px);
		@include rem('max-width', 480px);
	}
}

.b360-hamburger-menu-icon {
	position: absolute;
	top: 23px;
	left: $base-padding;
}

.b360-logo {
	height: $top-nav-height - ($base-padding + 10);
	@include rem(width, 215px);
}

.cls-1 {
	fill: url(#linear-gradient-small);
}

.cls-2 {
	fill: url(#linear-gradient-small-2);
}

.cls-3 {
	fill: #00385c;
}

.cls-4 {
	fill: url(#linear-gradient-small-3);
}
</style>
